import { StringConverter } from 'src/app/tools/ui/string-converter';
import { EStrategyPortfolioDocumentType } from './enum/strategy-portfolio-document-type';

export class PortfolioDocument {
    constructor() {
    }

    Id: number;
    Types: EStrategyPortfolioDocumentType[] = [];
    ElectronicDocumentId: string;
    Reference: string;
    Date: Date;
    FileName: string;
    FileExtension: string;

    // public get PortfolioDocumentTypesName() {
    //     return this.Types.map(x => StringConverter.getStrategyPortfolioDocumentTypeName(x));
    // }
    static mapFromJson(json): PortfolioDocument {
        const a = new PortfolioDocument;

        a.Id = json['id'];
        a.Types = json['types'].map((x: number) => EStrategyPortfolioDocumentType[x]);
        a.ElectronicDocumentId = json['electronicDocumentId'];
        a.Reference = json['reference'];
        a.Date = json['date'];
        a.FileName = json['fileName'];
        a.FileExtension = json['fileExtension'];

        return a;
    }
}
